import { Order, PAYMENT_PROVIDER_MAP, PaymentProvider } from '../types';

export const EMPTY_DISPLAY = '—';

export function displayValue(value?: string | null): string {
  if (value === undefined || value === null || String(value).trim() === '') {
    return EMPTY_DISPLAY;
  }
  return String(value);
}

export function resolvePaymentChannelText(
  order: Pick<Order, 'paymentChannelText' | 'paymentChannel' | 'payMethodText'>,
): string {
  if (order.paymentChannelText?.trim()) {
    return order.paymentChannelText;
  }
  if (!order.paymentChannel && order.payMethodText?.trim()) {
    return order.payMethodText;
  }
  return EMPTY_DISPLAY;
}

export function resolvePaymentProviderText(
  order: Pick<Order, 'paymentProviderText' | 'paymentProvider'>,
): string {
  if (order.paymentProviderText?.trim()) {
    return order.paymentProviderText;
  }
  if (order.paymentProvider) {
    return PAYMENT_PROVIDER_MAP[order.paymentProvider as PaymentProvider] || EMPTY_DISPLAY;
  }
  return EMPTY_DISPLAY;
}
